import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import modelToMesh from "./modelToMesh";
import getGLTF from "./getGLTF";

// const createSphere = (color) => {
//     const sphereGeo = new THREE.SphereGeometry(0.1, 20, 20)
//     const sphereMat = new THREE.MeshBasicMaterial({ color })
//     return new THREE.Mesh(sphereGeo, sphereMat);
// }

const addArrowRotate = async (object3D) => {
    const posInfo = getPosInfo(object3D);

    // const leftArrow = createSphere(0x00ff00);
    const leftArrow = await modelToMesh((await getGLTF('/models/arrow-left.glb')).scene);
    leftArrow.position.set(object3D.position.x - 0.3, posInfo.bbox.max.y + 0.3, posInfo.bbox.min.z + posInfo.zSize / 2);
    leftArrow.updateMatrix();

    // const rightArrow = createSphere(0xff0000);
    const rightArrow = await modelToMesh((await getGLTF('/models/Strelka-v-pravo.glb')).scene);
    rightArrow.position.set(object3D.position.x + 0.3, posInfo.bbox.max.y + 0.3, posInfo.bbox.min.z + posInfo.zSize / 2);
    rightArrow.updateMatrix();

    return [leftArrow, rightArrow];
}

export default addArrowRotate;
